import { render, staticRenderFns } from "./RatingElementSettings.vue?vue&type=template&id=5f8f9f8a&scoped=true&"
import script from "./RatingElementSettings.vue?vue&type=script&lang=ts&"
export * from "./RatingElementSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8f9f8a",
  null
  
)

export default component.exports